import { useAbility } from '@casl/react';
import { AbilityContext } from '../../../abilities/Can';
import { isModule, isView } from '../../../helpers/windowLocation';

export const useCanUseAiFeatures = (hasNLSOnDashboardSplit: boolean) => {
	const ability = useAbility(AbilityContext);
	const isSimilaritySearchECA = ability.can('show', 'ai_similarity_search');

	const isCollectionDetailView =
		window.location.pathname.startsWith('/collections/view/') || // Regular collection detail view
		window.location.pathname.startsWith('/web/') || // Public collection detail view
		window.location.pathname.startsWith('/share/'); // Shared collection detail view

	const isSimilaritySearchSupportedModule = isModule('media') || isCollectionDetailView;
	const canUseSimilaritySearch = isSimilaritySearchECA && isSimilaritySearchSupportedModule;

	const isNLSSupportedModule =
		isModule('media') ||
		isCollectionDetailView ||
		(isView('dashboard') && hasNLSOnDashboardSplit);

	const canUseNLSSearch = isSimilaritySearchECA && isNLSSupportedModule;

	return { canUseSimilaritySearch, canUseNLSSearch };
};
